<template>

    <div class="container column-center">

        <h2 class="title">¡OHHHHH!</h2>
        <h2 class="title">Esta vez no has<br>tenido suerte</h2>

        <!-- <img src="/static/img/momento-ganador/no-ganador.png" alt="No ganador" class="imagen-no-ganador"> -->

        <p class="big-white">Recuerda que puedes volver a participar con los códigos que encontrarás en los envoltorios de Kojak Original y Kojak Pop.</p>
            
            <p class="big-white">Llévate una tirada extra compartiendo la promoción para que todos tus amigos también participen</p>

            <div class="share-box -links column-center">

                <div class="row-center btn-container">

           
                    <a @click="tryagain" target="_blank" :href="`http://www.facebook.com/sharer.php?u=${link}&t=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta`" class="share-button">
                        Compartir <span class="facebook">
                            <i class="fa fa-facebook"></i>
                        </span>
                    </a>
                    <a @click="tryagain" :href="`http://twitter.com/intent/tweet?text=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta&url=${link}`" target="blank" class="share-button">
                        Compartir <span class="twitter">
                            <i class="fa fa-twitter"></i>
                        </span>
                    </a>
                </div>

                <div class="row-center btn-container">
                    <a @click="tryagain"  target="_blank"  :href="`whatsapp://send?text=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta%0A${link}`" data-action="share/whatsapp/share" class="share-button">
                        Compartir <span class="whatsapp">
                            <i class="fa fa-whatsapp"></i>
                        </span>
                    </a>
                    <a @click="tryagain" :href="`mailto:?subject=Gana%20un%20viaje%20a%20Corea%20con%20Fiesta&body=${link}`" target="_blank" class="share-button">
                        Compartir <span class="envelope">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                        </span>
                    </a>
        

                </div>

            </div>


        <div class="back-to-init column-center">

            <h2 class="title">¿Tienes otro código?</h2>
            <p class="big-white">¡Vuelve al inicio y prueba suerte!</p>

            <a @click="backtoInit" class="btn">Volver</a>

        </div>

    </div>

</template>

<script>

    export default {
        name: "no-ganador",
        methods: {
            backtoInit() {
                this.$emit('reset');
            },
            tryagain(){
                this.$emit('tryagain');
            }
        },
        computed:{
            link(){
                return location.href;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/view-parts/momento-ganador/no-ganador.vue